import {PSingleLine} from 'components/TypographyShortcuts';
import {UserContext} from 'context/UserContext';
import React, {useContext} from 'react';
import pluralize from 'pluralize';
import {Grid} from '@material-ui/core';
import {dateFormatter} from 'components/forms/locale/utils';

const daysTilNextPayment = nextPaymentDate => {
    return (new Date(nextPaymentDate) - new Date()) / (24 * 3600 * 1000);
};

const NextPayment = ({item, ...props}) => {
    const {subscription} = useContext(UserContext);
    const daysSinceJoining = parseInt(
        (new Date() - new Date(subscription?.first_subscribed_datetime)) /
            (24 * 3600 * 1000)
    );
    const trialPeriod = daysSinceJoining < 14;
    const Wrapper = item ? Grid : React.Fragment;
    const wrapperProps = item ? {item: item} : {};

    return (
        <Wrapper {...wrapperProps}>
            <PSingleLine {...props}>
                Your {trialPeriod ? 'first' : 'next'} payment of $
                {`${subscription?.next_payment_amount}`} will be due on{' '}
                {dateFormatter(subscription?.next_payment_date)}.
            </PSingleLine>
        </Wrapper>
    );
};

const LastPayment = ({item, ...props}) => {
    const {subscription} = useContext(UserContext);
    const Wrapper = item ? Grid : React.Fragment;
    const wrapperProps = item ? {item: item} : {};

    if (subscription?.last_payment_date) {
        return (
            <Wrapper {...wrapperProps}>
                <PSingleLine {...props}>
                    Your previous payment of $
                    {subscription?.last_payment_amount} was processed on{' '}
                    {dateFormatter(subscription?.last_payment_date)}.
                </PSingleLine>
            </Wrapper>
        );
    } else {
        return null;
    }
};

const Greeting = ({item, ...props}) => {
    const {subscription} = useContext(UserContext);
    const daysSinceJoining = parseInt(
        (new Date() - new Date(subscription?.first_subscribed_datetime)) /
            (24 * 3600 * 1000)
    );
    const daysLeftOnTrial = 14 - daysSinceJoining;
    const trialPeriod = daysSinceJoining < 14;
    const Wrapper = item ? Grid : React.Fragment;
    const wrapperProps = item ? {item: item} : {};

    if (trialPeriod) {
        return (
            <Wrapper {...wrapperProps}>
                <PSingleLine {...props}>
                    Welcome to your free 14 day trial of MM-SEAS!{' '}
                    {daysLeftOnTrial > 1
                        ? `Only ${daysLeftOnTrial} ${pluralize(
                              'day',
                              daysLeftOnTrial
                          )} left of your trial period!`
                        : 'Last day of free trail!'}
                </PSingleLine>
            </Wrapper>
        );
    } else {
        return (
            <Wrapper {...wrapperProps}>
                <PSingleLine {...props}>
                    Member since{' '}
                    {new Date(
                        subscription?.first_subscribed_datetime
                    ).toLocaleDateString()}
                    .
                </PSingleLine>
            </Wrapper>
        );
    }
};

export default NextPayment;
export {LastPayment, NextPayment, Greeting, daysTilNextPayment};
